import PropTypes from 'prop-types';
import React, { Component } from 'react';
import events from 'yoda-core-components/lib/components/PointCross/events';
import findScrollableAncestor from 'yoda-core-components/lib/components/PointCross//FindScrollableAncestor';

/**
 * Point Cross originally authored by Rajendra kumar Vankadari
 */

const { on, off } = events;
const listeners = [];
let listenersToRemove = [];

/* istanbul ignore next */
class PointCross extends Component {
    static propTypes = {
        adios: PropTypes.bool,
        children: PropTypes.node,
        findYourAncestor: PropTypes.bool,
        lazyLoadComponent: PropTypes.bool,
        wrapperClass: PropTypes.string,
    };

    static defaultProps = {
        adios: false,
        children: '',
        findYourAncestor: false,
        lazyLoadComponent: false,
        wrapperClass: '',
    };

    constructor(props) {
        super(props);
        this.ticking = false;
        /* istanbul ignore if */
        if (typeof window !== 'undefined') {
            this.node = window;
        }

        /* istanbul ignore if */
        if (props.findYourAncestor) {
            this.node = findScrollableAncestor(this.rootNode);
        }

        this.state = {
            loadComponent: false,
        };
    }

    componentDidMount() {
        if (listeners.length === 0) {
            on(this.node, 'scroll', this.scrollEventCB);
            on(this.node, 'resize', this.scrollEventCB);
        }
        listeners.push(this);
        this.visibilityCheck(null, this);
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.adios) {
            //eslint-disable-line
            this.addToRemoveList(this);
        }
    }

    componentDidCatch(error) {
        // eslint-disable-next-line no-console
        console.error('PointCross Error - ', error);
    }

    componentWillUnmount() {
        off(this.node, 'scroll', this.scrollEventCB);
        off(this.node, 'resize', this.scrollEventCB);
    }

    ref = (node) => {
        this.rootNode = node;
    };

    scrollEventCB = (isInitial) => {
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                listeners.forEach((activeListener) => {
                    this.visibilityCheck(isInitial, activeListener);
                });
                this.ticking = false;
            });
        }
        this.ticking = true;
        this.removeListeners();
        // listeners.forEach((activeListener) => {
        //     this.visibilityCheck(isInitial, activeListener);
        // });
    };

    invokeAction = (eventObj, elementDimension, activeListener) => {
        const { inPoint, beforePoint, afterPoint } = activeListener.props;

        const { getBoundingClientRect, offsetTop, offsetBottom } = elementDimension;

        const elementInPoint =
            Math.abs(parseInt(getBoundingClientRect.top, 10)) <= offsetTop ||
            Math.abs(parseInt(getBoundingClientRect.bottom, 10)) < offsetBottom;
        const elementBeforePoint = parseInt(getBoundingClientRect.top, 10) > offsetTop;
        const elementAfterPoint = parseInt(getBoundingClientRect.bottom, 10) < offsetBottom;

        if (activeListener.rootNode && (beforePoint || inPoint || afterPoint)) {
            if (elementBeforePoint) {
                beforePoint && beforePoint(eventObj);
            }

            if (elementInPoint) {
                inPoint && inPoint(eventObj);
            }

            if (elementAfterPoint) {
                afterPoint && afterPoint(eventObj);
            }
        }
    };

    addToRemoveList = (activeListener) => {
        if (activeListener.props.once) {
            listenersToRemove.push(activeListener);
        }
    };

    removeListeners = () => {
        listenersToRemove.forEach((activeListener) => {
            const listenerIndex = listeners.indexOf(activeListener);
            if (listenerIndex !== -1) {
                listeners.splice(listenerIndex, 1);
            }
        });
        listenersToRemove = [];
    };

    checkIfInViewport = (elementDimension, activeListener, lazyLoadComponent) => {
        const windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
        const {
            getBoundingClientRect: { top, height },
            offsetTop,
            offsetBottom,
        } = elementDimension;
        const { onEnterViewport } = activeListener.props;

        const showContent =
            top - offsetTop <= windowInnerHeight && top + height + offsetBottom >= 0;
        if (showContent) {
            this.addToRemoveList(activeListener);
            this.removeListeners();
            onEnterViewport && onEnterViewport();
            lazyLoadComponent &&
                activeListener.setState({
                    loadComponent: true,
                });
        }
    };

    visibilityCheck = (eventObj, activeListener) => {
        const {
            bottomOffset,
            offset,
            topOffset,
            lazyLoadComponent,
            onEnterViewport,
        } = activeListener.props;
        const offsetBottom = parseInt(offset || bottomOffset, 10);
        const offsetTop = parseInt(offset || topOffset, 10);
        if (activeListener.rootNode) {
            const getBoundingClientRect = activeListener.rootNode.getBoundingClientRect();
            const elementDimension = {
                getBoundingClientRect,
                offsetBottom,
                offsetTop,
            };
            if (lazyLoadComponent || onEnterViewport) {
                activeListener.checkIfInViewport(
                    elementDimension,
                    activeListener,
                    lazyLoadComponent
                );
            } else {
                activeListener.invokeAction(eventObj, elementDimension, activeListener);
            }
        }
    };

    render() {
        const { lazyLoadComponent, wrapperClass } = this.props;
        const { loadComponent } = this.state;
        let displayComponent = true;
        if (lazyLoadComponent) {
            displayComponent = !!loadComponent;
        }
        return (
            <div ref={this.ref} className={wrapperClass}>
                {displayComponent ? this.props.children : null}
            </div>
        );
    }
}

export default PointCross;
